import { Modal as MantineModel } from "@mantine/core";

export interface ModelProps {
  opened: boolean;
  onClose: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  withCloseButton: boolean;
  size: string | number | undefined;
  className?: string;
}
const Modal = ({ opened, onClose, header: title, children, withCloseButton, size, footer, className }: ModelProps) => {
  return (
    <MantineModel
      styles={{
        header: {
          borderBottom: "1px solid #ccc",
          padding: "8px 12px ",
          marginRight: "0px",
        },
      }}
      padding={4}
      size={size}
      withCloseButton={withCloseButton}
      opened={opened}
      onClose={onClose}
      title={title}
      className={className}
      centered
    >
      {children}
      {footer}
    </MantineModel>
  );
};

export default Modal;
